<template lang="html">
  <section v-if="type==='web'" id="hotweb">
    <div class="content">
      <div class="header">
        <div v-if="type==='web'">
          <div class="title">行业热门优站</div>
        </div>
        <div v-if="type==='mobile'">
          <div class="title">分类移动媒体</div>
        </div>
      </div>
      <div class="category" v-if="type==='mobile'">
        <span :class="{active: categoryType === 'app'}" @click="changeMobileThead('app')">
          <img src="/static/launchPreview/category-app.png" alt="app">
        </span>
        <!-- <span :class="{active: categoryType === 'wap'}" @click="changeMobileThead('wap')">
          <img src="/static/launchPreview/category-wap.png" alt="wap">
        </span> -->
      </div>
      <div class="industry">
        <span v-for="(val,key) in industryList" :class="{active: key === currentIndustry}" @click="getIndustrySite(key, val.id, true)">{{ val.name }}</span>
      </div>
      <div class="text-center" style="color: #4285f4;margin-top: 20px;">点击右下角免费试投按钮，全品类优质行业网站推广马上免费试投</div>
      <div class="industry-list clearfix">
        <table class="table">
          <thead style="background-color: #4285f4;color:white">
            <tr>
              <th v-for="item in siteList.thead">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in siteList.tbody" class="hvr-pulse-shrink">
              <td><a :href='item.previewUrl' target="_blank"><img :src="item.logo" alt="" title='点击预览广告'></a></td>
              <td>{{ item.name }}</td>
              <td v-if="type === 'web'">{{ item.domain }}</td>
              <td v-else>{{ item.appos }}</td>
              <td>{{ item.pv }}</td>
              <td>{{ item.ip }}</td>
              <td class="showtype"><span v-for="i in item.showtype">{{i}}</span></td>
              <td>
                <button v-if="type === 'web'" class="btn-ghost" @click="openModal({head: '网盟试投设置', previewUrl: item.previewUrl})">免费试投</button>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination :initPage='page' :total-page="totalPage"  @go-page="goPage" @alert-tip="openModal" class="pull-right"></pagination>
      </div>

    </div>
    <modal :head="modalHead" :modalType="modalType" :subText="modalSubText" :preUrl="wapPreview" :cancelText="modalCancelText" v-show="modalShow" @colse-modal="closeModal" @sub-event="launchAd" @init-props="initProps">
      <div v-if="modalType==='alertTip'" slot="custom" v-html="modalContent"></div>
      <launch-temp v-else slot="launchTemp" :industry-list="industryList" ref="launchTemp"></launch-temp>
    </modal>
    <tips></tips>
  </section>
</template>

<script>
import bus from '../../../bus/bus.js'
import pagination from '../../widget/pagination/pagination.vue'
import modal from '../../widget/modal/modal.vue'
import launchTemp from '../../widget/temp/launchModal.vue'
import tips from '../../widget/tips/tips.vue'
import {spellLink} from './launch.js'

export default {
  data () {
    return {
      type: this.$route.params.type,
      industryList: [],
      currentIndustry: 0,
      currentIndustryId: undefined,
      siteList: { thead: undefined, tbody: undefined },
      categoryType: 'app',
      APP_THEAD: ['点击LOGO预览广告', '应用名称', '展示系统', '下载量', '日活量', '推广尺寸展示类型', '点击免费试投'],
      WEB_THEAD: ['点击LOGO预览广告', '网站名称', '域名', '日均PV', '日均IP', '推广尺寸展示类型', '点击免费试投'],
      totalPage: 20,
      pagesize: 8,
      page: 1,
      oldPage: 1,
      previewUrl: undefined,
      modalShow: false,
      modalType: 'modal',
      modalHead: undefined,
      modalContent: undefined,
      modalSubText: undefined,
      modalCancelText: undefined,
      wapPreview: undefined
    }
  },
  created () {
    this.initThead(this.type)
    this.getINdustryList(this.type)
  },
  watch: {
    '$route' (newVal, val) {
      this.type = newVal.params.type
      this.getINdustryList(this.type)
      this.initThead(this.type)
    }
  },
  methods: {
    getINdustryList (type) {
      type = type === 'web' ? 1 : 2
      this.$http.get(`${this.baseUrl}industry?type=${type}`)
      .then((res) => {
        const result = JSON.parse(res.data).result
        if (result) { this.industryList = [] }
        Object.keys(result).forEach((item) => {
          this.industryList.push(result[item])
        })
        this.currentIndustryId = this.industryList[0].id || 0
        this.getIndustrySite(0, this.industryList[0].id)
      })
    },
    initThead (type) {
      if (type === 'web') {
        this.$set(this.siteList, 'thead', this.WEB_THEAD)
      } else if (type === 'mobile') {
        this.$set(this.siteList, 'thead', this.APP_THEAD)
      }
    },
    changeMobileThead (mType) {
      this.$set(this, 'categoryType', mType)
      if (mType === 'app') {
        this.$set(this.siteList, 'thead', this.APP_THEAD)
      } else if (mType === 'wap') {
        this.$set(this.siteList, 'thead', this.WEB_THEAD)
      }
      this.getIndustrySite()
    },
    getIndustrySite (index, id, goone) {
      if (goone) {
        this.$set(this, 'page', 1)
      }
      const type = this.type === 'web' ? 1 : 2
      let mobiletype
      if (type === 2) {
        mobiletype = this.categoryType === 'app' ? 3 : 2
      }
      if (this.currentIndustry !== index && index !== undefined) { this.$set(this, 'currentIndustry', index) }
      if (this.currentIndustryId !== id && id) { this.$set(this, 'currentIndustryId', id) }
      this.$http.get(`${this.baseUrl}indusite?type=${type}&industryid=${this.currentIndustryId}&mobiletype=${mobiletype}&page=${this.page}&pagesize=${this.pagesize}`)
      .then((res) => {
        const result = JSON.parse(res.data).result
        if (result.datalist) {
          result.datalist.forEach((e) => {
            e.logo = this.imgUrl + e.logo
          })
          this.$set(this.siteList, 'tbody', result.datalist)
        } else {
          if (type === 1) {
            this.page = this.oldPage
            this.openModal({head: '温馨提示', content: '<div class="text-center">仅推广用户可见</div>'}, 'alertTip')
          }
        }
      })
    },
    goPage (data) {
      this.oldPage = this.page
      this.page = data.page
      this.getIndustrySite(this.currentIndustry, this.currentIndustryId)
    },
    openModal (info, type, wapPre) {
      if (info && info.head) { this.$set(this, 'modalHead', info.head) }
      if (info && info.content) { this.$set(this, 'modalContent', info.content) }
      if (info && info.subText) { this.$set(this, 'modalSubText', info.subText) }
      if (info && info.cancelText) { this.$set(this, 'modalCancelText', info.cancelText) }
      if (info && info.previewUrl) { this.$set(this, 'previewUrl', info.previewUrl) }
      if (type) { this.$set(this, 'modalType', type) }
      if (wapPre) {
        if (wapPre === '0') {
          wapPre = '/static/404.html'
        }
        this.$set(this, 'wapPreview', wapPre)
      }
      this.modalShow = true
      document.body.style.overflow = 'hidden'
    },
    closeModal () {
      this.modalShow = false
      document.body.style.overflow = 'auto'
      if (this.modalType === 'modal') {
        bus.$emit('reset-input')
      }
    },
    initProps () {
      this.$set(this, 'modalHead', undefined)
      this.$set(this, 'modalContent', undefined)
      this.$set(this, 'modalSubText', undefined)
      this.$set(this, 'modalCancelText', undefined)
      this.$set(this, 'modalType', 'modal')
    },
    launchAd () {
      const data = this.$refs.launchTemp.$data
      const launch = {}
      if (data.selectedId) {
         launch.id = data.selectedId
      } else {
        bus.$emit('show-tips', '请选择试投行业', 'danger')
        return
      }
      if (data.title && data.title.length <= 30) {
         launch.title = data.title.trim()
      } else {
        bus.$emit('show-tips', '推广主题填写有误', 'danger')
        return
      }
      if (data.contact && data.contact.length <= 200) {
         launch.contact = data.contact.trim()
      } else {
        bus.$emit('show-tips', '联系方式填写有误', 'danger')
        return
      }
      launch.industry = data.selectedIndustry
      data.link = data.link.trim() === '' ? 'www.adyun.com' : data.link
      launch.link = 'http://' + data.link
      spellLink(this.previewUrl, launch)
      this.$http.get(`${this.baseUrl}throw`, {params: launch}).then((res) => {
        console.log(res)
      })
      this.closeModal()
    }
  },
  components: {
    pagination,
    modal,
    launchTemp,
    tips
  }
}
</script>

<style lang="less" scoped>
  section {
    background-color: #f1f0f6;
    padding: 50px 0;
    .content {
      width: 1200px;
      margin: auto;
      .header {
        text-align: center;
        .title {
          font-size: 26px;
          margin-bottom: 20px;
        }
      }
      .industry {
        padding: 0;
        span {
          display: inline-block;
          width: 108px;
          height: 40px;
          background-color: #fff;
          border-radius: 4px;
          margin: 20px 28px 0 0;
          padding: 13px 0;
          text-align: center;
          transition: all 0.4s;
          &:nth-child(9n){
            margin: 0;
          }
          &:hover,&.active {
            background-color: #4285f4;
            color: #fff;
            cursor: pointer;
          }
        }
      }
      .category {
        text-align: center;
        margin: 20px 0;
        cursor: pointer;
        span {
          display: inline-block;
          width: 256px;
          height: 106px;
          border-radius: 4px;
          &+ span {
            margin-left: 60px;
          }
          &.active {
            border: 3px solid #4285f4;
            box-shadow: 0px 0px 20px 5px #9cbfd8;
            img {
              border-radius: 0;
            }
          }
          img {
            border-radius: 4px;
          }
        }
      }
      .industry-list {
        margin: 20px 0;
        .table {
          width: 100%;
          border-spacing: 0;
          color: #333;
          margin-bottom: 20px;
          thead th {
            height: 50px;
          }
          tbody {
            background: #fff;
            tr {
              width: 100%;
              transition: box-shadow 0.4s;
              &:hover {
                box-shadow: 0 0 5px 5px #eee;
                z-index: 200;
              }
              td {
                padding: 0;
                height: 100px;
                // border-top: 1px solid #f5f5f5;
                border-bottom: 1px solid #f5f5f5;
                text-align: center;
                font-size: 12px;
                min-width: 120px;
                img {
                  width: 120px;
                }
                .btn-ghost {
                  padding: 8px 14px;
                  border-radius: 4px;
                  background-color: #fff;
                  border: 1px solid #4285f4;
                  outline: none;
                  cursor: pointer;
                  color: #4285f4;
                  display: inline-block;
                  &:hover {
                    background-color: #4285f4;
                    color: #fff;
                  }
                }
                &.showtype span + span{
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// launchPreview.vue?e3417934